// extracted by mini-css-extract-plugin
export default {"scrollToTopButton":"styles_scrollToTopButton__PZktn"};